import React from "react";
import { connect } from "react-redux";
import "./_RingSelectList.scss";
import { withRouter } from "react-router-dom";
import {
  toggleRingSelectModal,
  toggleHolderRingCollections,
  selectActiveRingFromModal,
  selectActiveRingByID,
} from "../../redux/actions";
import queryString from "query-string";

class RingSelectList extends React.Component {
  renderItems = () => {
    const {
      mainRings,
      holderRings,
      selectedMainRingCollections,
      selectedHolderRingCollections,
      modalMainRingOpen,
      modalHolderRingOpen,
    } = this.props;
    // List Main Rings:
    if (modalMainRingOpen) {
      if (mainRings && mainRings.items) {
        const items = this.getCorrespondingItems(
          selectedMainRingCollections,
          mainRings.items
        );
        if (items.length && items.length > 0) {
          return items.map((item) => {
            return (
              <React.Fragment key={item.fields.title}>
                {this.getRingItem(item, "yellow-gold")}
                {this.getRingItem(item, "rose-gold")}
                {this.getRingItem(item, "white-gold")}
                {this.getRingItem(item, "platinum")}
              </React.Fragment>
            );
          });
        }
      }
    }
    // List Holder Rings:
    else if (modalHolderRingOpen) {
      if (holderRings && holderRings.items) {
        const items = this.getCorrespondingItems(
          selectedHolderRingCollections,
          holderRings.items,
          false
        );
        if (items.length && items.length > 0) {
          return items.map((item) => {
            return (
              <React.Fragment key={item.fields.title}>
                {this.getRingItem(item, "yellow-gold", false)}
                {this.getRingItem(item, "rose-gold", false)}
                {this.getRingItem(item, "white-gold", false)}
                {this.getRingItem(item, "platinum", false)}
              </React.Fragment>
            );
          });
        }
      }
    }
  };

  getRingItem = (ringItem, material, mainRing = true) => {
    if (ringItem && ringItem.fields && material) {
      let price = "";
      let imageURL = null;
      let imageUpperUrl = null;
      let imageLowerUrl = null;
      let diamondImageUrl = null;
      let shadowUrl = null;
      let materialText = "keltakulta";
      switch (material) {
        case "rose-gold":
          price =
            ringItem.fields.priceRoseGold === 0
              ? "Kysy hintaa"
              : `Hinta: ${ringItem.fields.priceRoseGold}`;
          imageURL = mainRing ? ringItem.fields.imageRoseGoldURL : null;
          diamondImageUrl = ringItem.fields.imageRoseGoldDiamondURL
            ? ringItem.fields.imageRoseGoldDiamondURL
            : null;
          shadowUrl = ringItem.fields.imageRoseGoldShadowURL;
          imageUpperUrl = !mainRing
            ? ringItem.fields.imageRoseGoldUpperURL
            : null;
          imageLowerUrl = !mainRing
            ? ringItem.fields.imageRoseGoldLowerURL
            : null;
          materialText = "ruusukulta";
          break;
        case "white-gold":
          price =
            ringItem.fields.priceWhiteGold === 0
              ? "Kysy hintaa"
              : `Hinta: ${ringItem.fields.priceWhiteGold}`;
          imageURL = mainRing ? ringItem.fields.imageWhiteGoldURL : null;
          diamondImageUrl = ringItem.fields.imageWhiteGoldDiamondURL
            ? ringItem.fields.imageWhiteGoldDiamondURL
            : null;
          shadowUrl = ringItem.fields.imageWhiteGoldShadowURL;
          imageUpperUrl = !mainRing
            ? ringItem.fields.imageWhiteGoldUpperURL
            : null;
          imageLowerUrl = !mainRing
            ? ringItem.fields.imageWhiteGoldLowerURL
            : null;
          materialText = "valkokulta";
          break;
        case "platinum":
          price =
            ringItem.fields.pricePlatinum === 0
              ? "Kysy hintaa"
              : `Hinta: ${ringItem.fields.pricePlatinum}`;
          imageURL = mainRing ? ringItem.fields.imagePlatinumURL : null;
          diamondImageUrl = ringItem.fields.imagePlatinumDiamondURL
            ? ringItem.fields.imagePlatinumDiamondURL
            : null;
          shadowUrl = ringItem.fields.imagePlatinumShadowURL;
          imageUpperUrl = !mainRing
            ? ringItem.fields.imagePlatinumUpperURL
            : null;
          imageLowerUrl = !mainRing
            ? ringItem.fields.imagePlatinumLowerURL
            : null;
          materialText = "platina";
          break;
        default:
          price =
            ringItem.fields.priceYellowGold === 0
              ? "Kysy hintaa"
              : `Hinta: ${ringItem.fields.priceYellowGold}`;
          imageURL = mainRing ? ringItem.fields.imageYellowGoldURL : null;
          diamondImageUrl = ringItem.fields.imageYellowGoldDiamondURL
            ? ringItem.fields.imageYellowGoldDiamondURL
            : null;
          shadowUrl = ringItem.fields.imageYellowGoldShadowURL;
          imageUpperUrl = !mainRing
            ? ringItem.fields.imageYellowGoldUpperURL
            : null;
          imageLowerUrl = !mainRing
            ? ringItem.fields.imageYellowGoldLowerURL
            : null;
          materialText = "keltakulta";
          break;
      }
      const ringShadowClass = mainRing
        ? "ring-image"
        : "ring-image holder-shadow";
      return (
        <div
          className="ring-item"
          onClick={() => this.onButtonPress(ringItem, material)}
        >
          <div className="ring-image-container">
            {imageURL ? (
              <img
                src={imageURL}
                alt={`${ringItem.fields.title} ${material}`}
                className="ring-image"
              />
            ) : null}
            {diamondImageUrl ? (
              <img
                src={diamondImageUrl}
                alt={`${ringItem.fields.title} ${material} diamond`}
                className="ring-image"
              />
            ) : null}
            {imageUpperUrl ? (
              <img
                src={imageUpperUrl}
                alt={`${ringItem.fields.title} ${material} upper`}
                className="ring-image holder-upper"
              />
            ) : null}
            {imageLowerUrl ? (
              <img
                src={imageLowerUrl}
                alt={`${ringItem.fields.title} ${material} lower`}
                className="ring-image holder-lower"
              />
            ) : null}
            {shadowUrl ? (
              <img
                src={shadowUrl}
                alt={`${ringItem.fields.title} ${material} shadow`}
                className={ringShadowClass}
              />
            ) : null}
          </div>
          <div className="ring-title">
            <span className="ring-collection">
              {ringItem.fields.collectionTitle},{" "}
            </span>
            <span className="ring-material">{materialText}</span>
          </div>
          <span className="ring-price">{price}</span>
        </div>
      );
    }
  };

  onButtonPress = (item, material = "yellow-gold") => {
    if (item) {
      // Main Ring:
      if (item.sys.contentType.sys.id === "mainRing") {
        this.props.selectActiveRingFromModal(item, true);
        this.changeURL(item, material);
      }
      // Holder ring:
      else {
        this.props.selectActiveRingFromModal(item, false);
        this.changeURL(item, material, false);
      }
    }
  };

  changeURL = (newItem, material = "yellow-gold", mainRing = true) => {
    const { history } = this.props;
    const queryParams = history
      ? queryString.parse(history.location.search)
      : null;
    if (mainRing) {
      queryParams.ring = newItem.sys.id;
      queryParams["ring-material"] = material;
    } else {
      queryParams.holder = newItem.sys.id;
      queryParams["holder-material"] = material;
    }
    history.push({
      pathname: "/",
      search: queryString.stringify(queryParams),
    });
  };

  getCorrespondingItems = (selectedCollections, ringList, mainRing = true) => {
    const { activeMainRing, collectionsList, activeHolderRings } = this.props;
    const correspondingItems = [];
    const newCollection = [];
    /**
     * Check what collections are selected:
     */
    if (selectedCollections.length === 0 && collectionsList) {
      // IF no collections are selected -> Show all collections:
      for (let i = 0; i < collectionsList.items.length; i++) {
        newCollection.push(collectionsList.items[i].id);
      }
    } else {
      for (let i = 0; i < selectedCollections.length; i++) {
        newCollection.push(selectedCollections[i]);
      }
    }
    const activeRing = mainRing ? activeMainRing : activeHolderRings;
    if (newCollection && newCollection.length && ringList && activeRing) {
      for (let i = 0; i < newCollection.length; i++) {
        for (let y = 0; y < ringList.length; y++) {
          /**
           * If fetching main rings:
           */
          if (mainRing) {
            if (
              ringList[y].fields &&
              ringList[y].fields.collection &&
              ringList[y].fields.collection.sys.id === newCollection[i] &&
              ringList[y].fields.diamondSize === activeRing.fields.diamondSize
            ) {
              correspondingItems.push(ringList[y]);
            }
          } else {
            /**
             * If fetching holder rings -> don't compare diamond sizes:
             */
            if (
              ringList[y].fields &&
              ringList[y].fields.collection &&
              ringList[y].fields.collection.sys.id === newCollection[i]
            ) {
              correspondingItems.push(ringList[y]);
            }
          }
        }
      }
    }

    return correspondingItems;
  };

  render() {
    return <div className="ring-select-list">{this.renderItems()}</div>;
  }
}

const mapStateToProps = ({ ring, collection, configuratorPage }) => {
  const { mainRings, holderRings, activeMainRing, activeHolderRings } = ring;
  const {
    selectedMainRingCollections,
    selectedHolderRingCollections,
    collectionsList,
  } = collection;
  const { modalMainRingOpen, modalHolderRingOpen } = configuratorPage;

  return {
    mainRings,
    holderRings,
    activeMainRing,
    activeHolderRings,
    selectedMainRingCollections,
    selectedHolderRingCollections,
    modalMainRingOpen,
    modalHolderRingOpen,
    collectionsList,
  };
};

export default connect(mapStateToProps, {
  toggleRingSelectModal,
  toggleHolderRingCollections,
  selectActiveRingFromModal,
  selectActiveRingByID,
})(withRouter(RingSelectList));
